<div class="sip-card-assured">
  <img class="child-sip-banner" src="/assets/images/portfolio/child_on_sip_banner.png" alt="" srcset="">
  <img [hidden]="toggle" class="child-sip-banner-bg" src="/assets/images/portfolio/child_on_sip_banner_bg.png" alt="" srcset="">
  <img class="ketto-assured" src="/assets/images/portfolio/ketto_assured_logo.png" />
  <div class="card-content">
    <div class="pre-title">{{preTitle}}</div>
    <div class="title">The Monthly Giving Program</div>

    <div [hidden]="toggle" class="list">
      <div class="list-item"><i class="material-icons">done</i> <span>Aid critical patients every month</span></div>
      <div class="list-item"><i class="material-icons">done</i> <span>Allocate funds to campaigns that you prefer</span></div>
      <div class="list-item"><i class="material-icons">done</i> <span>Get regular updates about your impact</span></div>
      <div class="list-item"><i class="material-icons">done</i> <span>Unlock special rewards</span></div>
    </div>
  </div>

  <div [hidden]="toggle" class="payment-button">
    <button (click)="toggleBtn()" mat-button>Start Contributing Monthly</button>
    <div class="donors">
      <img loading="lazy" [attr.data-src]="supporterImg">
      <span><strong>{{subsCount?.monthlyDonors | inrFormat:'INR'}}</strong> contributors are giving monthly</span>
    </div>
  </div>

  <div class="offer-note">
    <app-offer-note></app-offer-note>
  </div>
</div>